@for (additionalInfoItem of additionalInfoItems; track trackByLabel($index, additionalInfoItem)) {
  <div class="trigger"
    [ngClass]="additionalInfoItem.position">
    @if (additionalInfoItem.icon) {
      <img class="info-icon"
        [ngClass]="{'link': additionalInfoItem.location}"
        (click)="onTriggerClicked(additionalInfoItem.label)"
        src="{{additionalInfoItem.icon}}"/>
    }
    @if (additionalInfoItem.location) {
      <span
        class="link"
        (click)="onTriggerClicked(additionalInfoItem.label)">
        {{additionalInfoItem.label}}
        @if (visibleComponents.includes(additionalInfoItem.label)) {
          {{ 'i18n.toggle.hide' | translate }}
        }
      </span>
    }
    @if (!additionalInfoItem.location) {
      <span>
        {{additionalInfoItem.label}}
      </span>
    }
  </div>
  <div #loadedComponent></div>
}
<div #componentsContainer></div>
